import { render } from "./RegisterDonePage.vue?vue&type=template&id=20e9a500&scoped=true"
import script from "./RegisterDonePage.vue?vue&type=script&lang=js"
export * from "./RegisterDonePage.vue?vue&type=script&lang=js"

import "./RegisterDonePage.vue?vue&type=style&index=0&id=20e9a500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e9a500"]])

export default __exports__